export default __webpack_public_path__ + "static/media/about-bg.bedc79f5.png";